<template>
  <div>
    <!-- BEGIN #slider -->
    <div id="slider" class="section-container slider p-0 bg-black-darker">
      <!-- BEGIN carousel -->
      <div id="main-carousel" class="carousel slide" data-ride="carousel">
        <!-- BEGIN carousel-inner -->
        <div class="carousel-inner">
            <!-- BEGIN item -->
          <div class="item active">
            <div class="bg-cover">
              <img src="../../assets/color-theme/img/slider/slider-integration.jpg" class="bg-cover-img" alt="" />
            </div>
            <div class="carousel-caption">
              <div class="container">
                <h3 class="title"><span>We connect physicians to researchers and developers</span></h3>
              </div>
            </div>
          </div>
          <!-- END item -->
          <!-- BEGIN item -->
          <div class="item">
            <div class="bg-cover">
              <img src="../../assets/color-theme/img/slider/slider-xray-1.jpg" class="bg-cover-img" alt="" />
            </div>
            <div class="carousel-caption">
              <div class="container">
                <h3 class="title"><span>We bring medical imaging Apps to Physicians</span></h3>
              </div>
            </div>
          </div>
          <!-- END item -->
          <!-- BEGIN item -->
          <div class="item">
            <div class="bg-cover">
              <img src="../../assets/color-theme/img/slider/slider-researchers.jpg" class="bg-cover-img" alt="" width="100%" height="600px" />
            </div>
            <div class="carousel-caption">
              <div class="container">
                <h3 class="title"><span>We help Researchers delivering medical imaging Apps</span></h3>
              </div>
            </div>
          </div>
          <!-- END item -->
          <!-- BEGIN item -->
          <div class="item">
            <div class="bg-cover">
              <img src="../../assets/color-theme/img/slider/slider-dev.png" class="bg-cover-img" alt="" />
            </div>
            <div class="carousel-caption">
              <div class="container">
                <h3 class="title"><span>We translate medical imaging algorithms into Apps</span></h3>
              </div>
            </div>
          </div>
          <!-- END item -->
          <!-- BEGIN item -->
          <div class="item">
            <div class="bg-cover">
              <img src="../../assets/color-theme/img/slider/cover-3.jpg" class="bg-cover-img" alt="" />
            </div>
            <div class="carousel-caption">
              <div class="container">
                <h3 class="title"><span>We empower independent medical imaging Apps developers</span></h3>
              </div>
            </div>
          </div>
          <!-- END item -->
        </div>
        <!-- END carousel-inner -->
        <a class="left carousel-control" href="#main-carousel" data-slide="prev"> 
          <i class="fa fa-angle-left"></i> 
        </a>
        <a class="right carousel-control" href="#main-carousel" data-slide="next"> 
          <i class="fa fa-angle-right"></i> 
        </a>
      </div>
      <!-- END carousel -->
    </div>
    <div class="section-container bg-silver">
      <!-- BEGIN container -->
      <div class="container">
        <!-- BEGIN category-container -->
        <div class="category-container">
          <!-- BEGIN category-sidebar -->
          <div class="category-sidebar">
            <sidebar v-on:conditionsChange="search" v-on:searchText="searchText"></sidebar>
          </div>
          <!-- END category-sidebar -->
        </div>
        <!-- BEGIN category-detail -->
        <div class="category-detail">
          <div id="gallery" class="gallery row p-0 m-0">
            <h4 v-if="searchProducts" style="margin: 0 0 5px 10px;padding: 0;">Your search</h4>
            <app-list v-if="searchProducts" :products='searchProducts'></app-list>
            <app-list v-if="!searchProducts" :products='products'></app-list>
          </div>
          <!-- END item-row -->
        </div>
        <!-- END category-detail -->
        <!-- END category-container -->
      </div>
      <!-- END container -->
    </div>
    <footer-build-your-app></footer-build-your-app>
    <footer-subscribe></footer-subscribe>
  </div>
</template>
<script>
import Banner from '@/components/Banner'
import AppList from '@/components/AppList'
import Sidebar from '@/components/Sidebar'
import FooterBuildYourApp from '@/components/FooterBuildYourApp'
import FooterSubscribe from '@/components/FooterSubscribe'
import Vuex from 'vuex'

export default {
  components: {
    banner: Banner,
    'app-list': AppList,
    sidebar: Sidebar,
    'footer-build-your-app': FooterBuildYourApp,
    'footer-subscribe': FooterSubscribe
  },
  name: 'Home',
  data() {
    return {
      products: [],
      searchProducts: null
    }
  },
  computed: {
    ...Vuex.mapGetters(['isAuthenticated'])
  },
  watch: {
    $route(to, from) {
      // react to route changes...
      if (to.query.search !== from.query.search && to.query.search) {
        this.loadMyApps()
      } else {
        this.fetchData().then(products => (this.products = products))
      }
    }
  },
  created: function () {
    if (this.isAuthenticated && this.$route.query.search === 'MyApps') {
      this.loadMyApps()
    } else {
      this.fetchData().then(products => (this.products = products))
    }
  },
  methods: {
    ...Vuex.mapActions(['startLoading', 'endLoading']),

    loadMyApps() {
      this.startLoading()
      this.$http
        .get('purchase', { params: { populate: 'product' } })
        .then(
          response => {
            // transform into products
            this.products = response.data.map(purchase => {
              return purchase.product
              // To avoid error when App is no longer in the App Store (Deleted)
            }).filter(product => product)
          },
          response => {
            // error callback
            console.log(response)
          }
        )
        .finally(() => {
          this.endLoading()
        })
    },
    searchText(text) {
      // TODO: Cancel previous promise ?
      if (text) {
        const params = {
          conditions: {
            $text: { $search: text }
          }
        }
        this.fetchData(params).then(
          products => (this.searchProducts = products)
        )
      }
    },
    search(conditions) {
      this.fetchData({ conditions }).then(
        products => (this.searchProducts = products)
      )
    },
    fetchData(params) {
      this.startLoading()
      params = params || {}
      params.populate = 'author'
      return this.$http
        .get('product/public', {
          params: params
        })
        .then(
          response => {
            return response.data
          },
          err => {
            // error callback
            console.log(err)
          }
        )
        .finally(() => {
          this.endLoading()
        })
    }
  }
}
</script>
<style>
.category-container {
  width: 220px;
  float: left;
}

.category-container .category-sidebar {
  width: 200px;
  padding: 20px;
}

.category-detail {
  margin-left: 250px;
}

.gallery .image {
  width: 250px;
  display: table-cell;
  overflow: hidden;
  padding: 0 0 10px 10px;
}

.gallery .image-inner {
  position: relative;
  background: #fff;
  border-radius: 3px 3px 0 0;
}

.gallery .image a:focus,
.gallery .image a:hover {
  opacity: .8;
}

.gallery .image a {
  transition: all .2s linear;
}

.gallery .image img {
  width: 100%;
  height: 170px;
  border-radius: 3px 3px 0 0;
}

.gallery .image-caption {
  position: absolute;
  top: 15px;
  left: 0;
  background: rgba(0, 0, 0, .6);
  color: #fff;
  padding: 5px 15px;
  margin: 0;
}

.gallery .image-info {
  background: #fff;
  padding: 15px;
  border-radius: 0 0 3px 3px;
  border-top: 1px solid #eee;
  height: 130px;
  box-shadow: 1px 1px #eee;
}

.gallery .image-info .title {
  margin: 0 0 10px;
  line-height: 18px;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.gallery .image-info {
  font-size: 85%;
}

.gallery .image-info .rating {
  line-height: 20px;
  margin: 0 0 3px;
  padding-top: 10px;
}

.gallery .rating span.fa-star {
  display: inline-block;
  color: #999;
}

.gallery .rating span.fa-star.full {
  color: #FF8500;
}

.gallery .image-info .desc {
  line-height: 16px;
  font-size: 12px;
  height: 25px;
  overflow: hidden;
}

.gallery .image-info .label {
  padding: 5px 6px;
  font-size: 12px;
  display: block;
  max-width: 70px;
  margin-bottom: 7px;
}


.gallery .card-default {
  background: white;
  margin-left: 10px;
  margin-right: 20px;
  padding: 30px 10px 10px 10px;
  height: 300px;
  border-radius: 3px 3px 0 0;
}

</style>
<style scoped>
.carousel-inner {
  height: 450px;
}
.carousel-inner .carousel-caption .title {
  font-size: 54px;
  background: rgba(0,0,0,0);
  padding: 25px 10px;
  margin-top: 55px;
  text-shadow: 0px 0px 1px #999;
}
/* slide background */

.carousel-inner .bg-cover:before {
  content: " ";
  display: table;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9;
  height: 700px;
  width: 2500px;
  background:rgba(36, 42, 48, 0.8);
}

</style>



// WEBPACK FOOTER //
// src/pages/public/Home.vue